import React, { useState } from 'react';
import {
  AppBar, Toolbar, IconButton, Typography, Box, Avatar, Menu,
  MenuItem, ListItemIcon, Divider, Chip, Tooltip
} from '@mui/material';
import {
  Menu as MenuIcon, AccountCircle, Logout, Person,
  NotificationsNone
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { INDESAP } from '../../theme';

const ROLE_LABELS = {
  superadmin: { label: 'Super Admin', color: 'error' },
  teamlead: { label: 'Líder de Equipo', color: 'primary' },
  member: { label: 'Miembro', color: 'default' }
};

export default function Navbar({ drawerWidth, onMenuClick, isMobile }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenu = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLogout = () => {
    handleClose();
    logout();
    navigate('/login');
  };

  const roleInfo = ROLE_LABELS[user?.role] || ROLE_LABELS.member;
  const initials = user?.name
    ? `${user.name[0]}${user.lastName ? user.lastName[0] : ''}`.toUpperCase()
    : user?.email?.[0]?.toUpperCase() || '?';

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        width: isMobile ? '100%' : `calc(100% - ${drawerWidth}px)`,
        ml: isMobile ? 0 : `${drawerWidth}px`,
        borderBottom: '1px solid rgba(27,43,75,0.08)'
      }}
    >
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box display="flex" alignItems="center" gap={1}>
          {isMobile && (
            <IconButton edge="start" onClick={onMenuClick} sx={{ color: INDESAP.navy }}>
              <MenuIcon />
            </IconButton>
          )}
          {isMobile && (
            <Typography variant="h6" sx={{ fontWeight: 700, color: INDESAP.navy, letterSpacing: '0.05em' }}>
              INDESAP
            </Typography>
          )}
        </Box>

        <Box display="flex" alignItems="center" gap={1}>
          <Chip
            label={roleInfo.label}
            color={roleInfo.color}
            size="small"
            sx={{ fontWeight: 600, display: { xs: 'none', sm: 'flex' } }}
          />
          <Tooltip title="Notificaciones">
            <IconButton sx={{ color: INDESAP.navy }}>
              <NotificationsNone />
            </IconButton>
          </Tooltip>
          <Tooltip title={user?.email || ''}>
            <IconButton onClick={handleMenu} sx={{ p: 0.5 }}>
              <Avatar sx={{ width: 36, height: 36, bgcolor: INDESAP.navy, fontSize: '0.85rem', fontWeight: 700 }}>
                {initials}
              </Avatar>
            </IconButton>
          </Tooltip>
        </Box>
      </Toolbar>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}
        PaperProps={{ sx: { minWidth: 220, mt: 1 } }}>
        <Box sx={{ px: 2, py: 1.5 }}>
          <Typography variant="subtitle2" fontWeight={700}>
            {user?.name ? `${user.name} ${user.lastName || ''}` : 'Usuario'}
          </Typography>
          <Typography variant="caption" color="text.secondary">{user?.email}</Typography>
        </Box>
        <Divider />
        <MenuItem onClick={() => { handleClose(); navigate('/profile'); }}>
          <ListItemIcon><Person fontSize="small" /></ListItemIcon>
          Mi Perfil
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout} sx={{ color: 'error.main' }}>
          <ListItemIcon><Logout fontSize="small" color="error" /></ListItemIcon>
          Cerrar Sesión
        </MenuItem>
      </Menu>
    </AppBar>
  );
}
